import React from 'react';
import { connect } from 'react-redux';

import { entitySelectors } from '@store/entity/selectors';
import { guestSelectors } from '@store/guest/selectors';
import { yourJourneySelectors } from '@store/yourJourney/selectors';

import { SpaLandingPageV2 } from './SpaLandingPageV2';
import { SpaLandingPageV2OwnProps, SpaLandingPageV2StoreProps } from './SpaLandingPageV2.types';

const mapStateToProps = (state): SpaLandingPageV2StoreProps => ({
  property: entitySelectors.getProperty(state),
  spaPage: entitySelectors.getSpaPage(state),
  journeyParams: yourJourneySelectors.getParsedJourneyParams(state),
  isSpaDaysEnabled: entitySelectors.isSpaDaysEnabled(state),
  isTreatmentEnabled: entitySelectors.isTreatmentEnabled(state),
  isFacilitiesEnabled: guestSelectors.userHasAccessToSpaEntity(state, 'facilities'),
  isClassEnabled: entitySelectors.isClassEnabled(state),
  userHasAccessToSpaClasses: guestSelectors.userHasAccessToSpaEntity(state, 'classes'),
});

export const SpaLandingPageV2Connected: React.ComponentType<SpaLandingPageV2OwnProps> =
  connect(mapStateToProps)(SpaLandingPageV2);
